import { t } from '../lib/i18n';

interface PrintHeaderProps {
  /** Main title shown below the brand. */
  title: string;
  /** Optional subtitle (account name, date range, attribution, etc.). */
  subtitle?: string;
}

/**
 * Branded header that only appears when printing (.print-only class).
 * Place it as the first child of a .print-region so it sits at the top of
 * every printed / saved-PDF output.
 */
export default function PrintHeader({ title, subtitle }: PrintHeaderProps) {
  const generatedAt = new Date().toLocaleString('es-MX');

  return (
    <div className="print-only" style={{ marginBottom: '16px', borderBottom: '2px solid #d1d5db', paddingBottom: '12px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: '20px', color: '#111827', letterSpacing: '-0.01em' }}>
            {t.appName}
          </div>
          <div style={{ fontWeight: 600, fontSize: '15px', color: '#111827', marginTop: '2px' }}>
            {title}
          </div>
          {subtitle && (
            <div style={{ fontSize: '12px', color: '#374151', marginTop: '2px' }}>
              {subtitle}
            </div>
          )}
        </div>
        <div style={{ fontSize: '11px', color: '#6b7280', textAlign: 'right' }}>
          {t.print.generatedOn}: {generatedAt}
        </div>
      </div>
    </div>
  );
}
